export default __webpack_public_path__ + "adac9acbb951a85d28279b3a5f672d08.svg";